import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { PaperworkEntryDetails, PaperworkEntryImageList, PaperworkEntryTagList, PaperworkHistoryModal, PaperworkEntryEdit } from 'modules/paperwork-entry';
import { Loader, ErrorMessage } from 'components';
import { Link } from 'react-router-dom';

@inject(rootStore => ({
    paperworkEntryStore: rootStore.paperworkEntryStore,
    routerStore: rootStore.routerStore,
    authStore: rootStore.authStore
}))
@observer
class PaperworkEntryDetailPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            historyModalIsOpen: false
        };

        this.handleRefresh = this.handleRefresh.bind(this);
        this.closeHistoryModal = this.closeHistoryModal.bind(this);
        this.openHistoryModal = this.openHistoryModal.bind(this);
    }

    async componentDidMount() {
        await this.refreshData();
    }

    async handleRefresh() {
        await this.refreshData();
    }

    async refreshData() {
        const { paperworkEntryStore, match } = this.props;
        await this.props.paperworkEntryStore.getPaperworkStatuses();
        await paperworkEntryStore.getPaperworkEntry(match.params.id);
        await paperworkEntryStore.getPaperworkEntryHistory(match.params.id)
    }

    componentWillUnmount() {
        this.props.paperworkEntryStore.clearMessages();
    }

    openHistoryModal(event, obj) {
        this.setState({
            historyModalIsOpen: true,
        });
    }

    closeHistoryModal() {
        this.setState({
            historyModalIsOpen: false,
        });
    }

    render() {
        const { loading, images, tags, paperworkEntry, paperworkEntryHistory, loadingImages, error } = this.props.paperworkEntryStore;
        const { routerStore, paperworkEntryStore } = this.props;

        const goBack = () => {
            paperworkEntryStore.setDontClearFlag(true);
            routerStore.replace('/paperworks');
        }

        const userCanEditStatus = () => {
           return this.props.authStore.userIsInRole("Billing Company Coder");
        }

        if (loading) {
            return <Loader />
        }

        if (paperworkEntry) {
            return (
                <div>
                    <div className="clear">
                        <h3 className="pull type--medium">{getFullName(paperworkEntry)}</h3>
                        <button className="push btn btn--med btn--primary" onClick={goBack}>
                            Back
                        </button>
                    </div>

                    <div className="separator--primary spc--bottom--sml spc--top--sml"></div>

                    <div className="row">
                        <div className="col col-sml-12 col-lrg-5 spc--bottom--med">
                            <div className="box box--sml box--white box__shadow--1 spc--bottom--med">
                                <PaperworkEntryDetails
                                    username={paperworkEntry.user.username}
                                    userFullName={getFullName(paperworkEntry.user)}
                                    patientFullName={getFullName(paperworkEntry)}
                                    physicianProductivityPoints={paperworkEntry.physicianProductivityPoints}
                                    dos={paperworkEntry.dos}
                                    createdOn={paperworkEntry.createdOn}
                                    client={paperworkEntry.client.name}
                                    status={paperworkEntry.paperworkStatus.description}
                                />
                                <p className="type--tiny type--color--light type--bold type--letterspace--wide type--uppercase spc--bottom--sml">Tags</p>
                                {tags && <PaperworkEntryTagList tags={tags} />}

                                { paperworkEntryHistory && paperworkEntryHistory.records && paperworkEntryHistory.records.length > 0 &&                        
                                <button className="btn btn--med btn--primary spc--bottom--med" 
                                        onClick={this.openHistoryModal} >
                                    View History
                                </button>
                                }

                                { paperworkEntryHistory && paperworkEntryHistory.records && paperworkEntryHistory.records.length > 0 &&
                                <PaperworkHistoryModal
                                    onClose={this.closeHistoryModal}
                                    isOpen={this.state.historyModalIsOpen} 
                                    historyData={paperworkEntryHistory}                              
                                ></PaperworkHistoryModal>
                                }

                            </div>
                            { userCanEditStatus() && 
                                <PaperworkEntryEdit
                                paperworkEntry={paperworkEntry}
                            />  
                            }
                        </div>
                        <div className="col col-sml-12 col-lrg-7">
                            <div className="box box--sml box--white box__shadow--1">
                                <h4 className="type--small type--bold type--letterspace--wide type--uppercase spc--bottom--sml">Images</h4>
                                {
                                    loadingImages ? <Loader /> : <PaperworkEntryImageList images={images} />
                                }                                
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        return <ErrorMessage message={error} />
    }
}

function getFullName(item) {
    if (item.fullName) {
        return item.fullName;
    }
    else if (item.firstName && item.lastName) {
        return `${item.firstName} ${item.lastName}`;
    }

    return '';
}

export { PaperworkEntryDetailPage }




// WEBPACK FOOTER //
// ./src/pages/PaperworkEntryDetailPage.js